import { asset } from '@/lib/asset';

export type ContentBlock =
  | { kind: 'heading'; text: string }
  | { kind: 'paragraph'; text: string }
  | { kind: 'image'; url: string; alt?: string };

export interface PageContent {
  title: string;
  blocks: ContentBlock[];
  cta?: {
    label: string;
    url: string;
  };
}

export const PAGES: Record<string, PageContent> = {
  about: {
    title: 'О JohnCalliano Lounge',
    blocks: [
      { kind: 'heading', text: 'Место, которое сложно описать словами. Проще прийти.' },
      {
        kind: 'paragraph',
        text:
          'JohnCalliano Lounge — киберпанк-лаунж в самом центре Москвы. Коктейльный бар, ' +
          'авторская паназиатская и европейская кухня, три этажа арт-пространства с ' +
          'работами современных художников.',
      },
      {
        kind: 'paragraph',
        text:
          'Каждый этаж рассказывает свою часть одной большой истории — о человеке, ' +
          'времени и о том, что остаётся после.',
      },
      {
        kind: 'paragraph',
        text: 'Проект авторства Антона Гайворонского, создателя JohnCalliano TV.',
      },
      { kind: 'image', url: asset('/logo.jpg'), alt: 'JohnCalliano Lounge' },
    ],
  },
  kitchen: {
    title: 'Кухня',
    blocks: [
      { kind: 'heading', text: 'Авторская кухня' },
      {
        kind: 'paragraph',
        text:
          'Смешение паназиатской, европейской и калифорнийской кухни в современном ' +
          'прочтении от нашего Шефа — Алексея Арделяна.',
      },
      {
        kind: 'paragraph',
        text:
          'В нашей изысканной кухне и баре мы гордимся тем, что каждое блюдо и напиток — ' +
          'это не просто угощение, а гастрономическая симфония, пробуждающая чувства.',
      },
    ],
  },
  bar: {
    title: 'Бар',
    blocks: [
      { kind: 'heading', text: 'Коктейльное меню' },
      {
        kind: 'paragraph',
        text:
          'Коктейльная карта от бартендеров SILENCIO — лучшего бара Москвы 2024. ' +
          'Классика, авторские миксы и сезонные позиции.',
      },
    ],
  },
  hookah: {
    title: 'Кальянная карта',
    blocks: [
      { kind: 'heading', text: 'Уникальный ароматический опыт' },
      {
        kind: 'paragraph',
        text:
          'Кальяны на PORSCHE DESIGN и DESVALL. Авторские миксы табаков и ' +
          'сопровождение от лучших кальянных мастеров.',
      },
    ],
  },
  parking: {
    title: 'Парковка',
    blocks: [
      { kind: 'heading', text: 'Как припарковаться' },
      {
        kind: 'paragraph',
        text:
          'Находимся в центре Москвы на Солянке. Парковка платная, муниципальные карманы ' +
          'вдоль улицы.',
      },
      {
        kind: 'paragraph',
        text: 'Свободные места и удобный подъезд уточняйте у администратора при бронировании.',
      },
    ],
    cta: {
      label: 'Построить маршрут',
      url: 'https://yandex.com/maps/org/johncalliano_lounge/67155683857/?ll=37.637524%2C55.754031&z=17.06',
    },
  },
};

export const MENU_IMAGES = [
  '/menu/menu.png',
  '/menu/menu_hookah.png',
  '/menu/menu_drinks.png',
  '/menu/menu_coctails.png',
  '/menu/menu_alc.png',
  '/menu/menu_alc_2.png',
].map(asset);
